import { render, staticRenderFns } from "./MiraProcessFlow.vue?vue&type=template&id=0bae3df2&scoped=true&"
import script from "./MiraProcessFlow.vue?vue&type=script&lang=ts&"
export * from "./MiraProcessFlow.vue?vue&type=script&lang=ts&"
import style0 from "./MiraProcessFlow.vue?vue&type=style&index=0&id=0bae3df2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bae3df2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VProgressCircular,VRow})
